import { sdk } from '../../config'
import {
  GetApiKeyInventoryPartsRequest,
  GetServiceTechniciansByApiKeyRequest,
  InventoryPartEntry,
  UserProfile
} from '../../sdk'
import { api } from './'

const getServiceTechniciansByApiKey =
  sdk.getServiceTechniciansByApiKey.bind(sdk)
const getApiKeyInventoryParts = sdk.getApiKeyInventoryParts.bind(sdk)

const customerPortalApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getServiceTechniciansByApiKey: builder.query<
      UserProfile[],
      GetServiceTechniciansByApiKeyRequest
    >({
      query: (req) => () => getServiceTechniciansByApiKey(req),
      providesTags: (result, _, req) =>
        result
          ? [
              ...result.map((entry) => ({
                type: 'User' as const,
                id: entry.id!
              })),
              { type: 'User', id: req.xAPIKey }
            ]
          : ['User']
    }),
    getApiKeyInventoryParts: builder.query<
      InventoryPartEntry[],
      GetApiKeyInventoryPartsRequest
    >({
      query: (req) => () => getApiKeyInventoryParts(req),
      providesTags: (result, _, req) =>
        result
          ? [
              ...result.map((entry) => ({
                type: 'InventoryPart' as const,
                id: entry.id!
              })),
              {
                type: 'InventoryPart',
                id: req.xAPIKey
              }
            ]
          : ['InventoryPart']
    })
  })
})

export const {
  useGetServiceTechniciansByApiKeyQuery,
  useGetApiKeyInventoryPartsQuery
} = customerPortalApi
